<template>
  <div style="z-index: 999999 !important; background-color: #ffffff">
    <!--  系统信息弹框  -->
    <div v-if="tipDialog01" class="sysInfo">
      <!--  头部   -->
      <div class="header">
        <div>
          <span>{{ $t('GlobalSetObj.sysMessage') }}</span>
          <span style="margin-left: 10px">
            <i class="iconfont icon-a-lujing642" style="font-size: 18px" />
          </span>
        </div>
        <div>
          <i class="iconfont icon-a-zu389" style="font-size: 14px" @click="closeMessage" />
        </div>
      </div>
      <!--  信息   -->
      <div class="infoContant">
        <div v-if="messageObj.msgType === 4">
          <div @click.stop="getImgSrc" v-html="msgDataContent" />
          <el-link
            type="primary" @click="toRecyclingManagement"
          >{{ $t('home.lijiReturn') }}
          </el-link>
        </div>
        <div v-else @click.stop="getImgSrc" v-html="msgDataContent" />
      </div>
      <!--  关闭  -->
      <div style="display: flex; justify-content: flex-end; margin-right: 10px">
        <el-button
          v-if="messageObj.isRead === 0" plain size="mini"
          @click="notTip"
        >{{ $t('GlobalSetObj.notTip') }}
        </el-button>
        <el-button
          size="mini" type="primary" @click="closeMessage"
        >{{ $t('GlobalSetObj.close') }} {{ countdown }}s
        </el-button>
      </div>
    </div>
    <!--  强制提醒   -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title="$t('GlobalSetObj.tips')"
      :visible.sync="tipDialog02"
      top="8vh"
      width="600px"
    >
      <template #title>
        <div>
          <span style="margin-right: 10px">
            <i class="iconfont icon-a-lujing642" style="font-size: 18px" />
          </span>
          <span>{{ messageObj.title }}</span>
        </div>
      </template>
      <!--  信息   -->
      <div class="infoContant" style="height: 500px; overflow-y: auto">
        <div @click.stop="getImgSrc" v-html="msgDataContent" />
      </div>
      <!--  关闭  -->
      <div class="flx-center">
        <el-button
          :disabled="isDisable" size="small" type="primary"
          @click="notTip"
        >{{ $t('GlobalSetObj.close') }}
          <span v-if="compulsionCountdown">{{ compulsionCountdown }}s</span>
        </el-button>
      </div>
    </el-dialog>
    <!--  轨迹停更预警  -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="tipDialog03"
      title="轨迹停更预警"
      top="8vh"
      width="650px"
    >
      <div style="display: flex; align-items: center">
        <div><i class="el-icon-warning" style="font-size: 25px; color: red" /></div>
        <div style="margin-left: 8px; margin-bottom: 10px">
          <div style="font-size: 16px; font-weight: bold">
            以下客户包裹轨迹停更时长即将超期，请尽快核实轨迹信息!
          </div>
          <div>轨迹停更超过客户规定时间将面临罚款，请尽快处理!</div>
        </div>
      </div>
      <el-table
        ref="tableRef"
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        height="420"
        style="width: 100%"
      >
        <el-table-column label="客户" min-width="150" prop="scanNumber" />
        <el-table-column label="包裹数量" min-width="100" prop="customerNumber" />
        <el-table-column label="客户" min-width="100" prop="customerName" />
        <el-table-column label="包裹数量" min-width="90" prop="collectStatusName" />
      </el-table>
      <!--  关闭  -->
      <div class="flx-center" style="margin: 10px 0">
        <el-button size="small" @click="notTip">{{ '我已知晓' }}</el-button>
        <el-button size="small" type="primary" @click="notTip">{{ '立即处理' }}</el-button>
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <ElImageViewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />
  </div>
</template>

<script>
import store from '@/store';
import { readMessageUser, selectMessageUser } from '@/api/messageCenter';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';

export default {
  components: {
    ElImageViewer
  },
  props: {
    messageType: {
      type: Boolean,
      required: false
    },
    messageObj: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      tableData: [],
      countdown: 0,
      intervalId: null,
      messageShow: true,
      getmessageContent: '',
      getmessageNumber: 0,
      tipDialog01: false,
      tipDialog02: false,
      tipDialog03: false,
      isDisable: true,
      msgDataContent: '',
      compulsionCountdown: 10,
      showViewer: false,
      imgArr: []
    };
  },
  mounted() {
    this.countdown = this.messageObj.messageInfoTime;
    console.log(this.messageObj, 'messageObj');
    if (this.messageObj.msgData) {
      this.msgDataContent = this.messageObj.msgData.replace(/<p>/g, '<p style="margin: 0;">');
    }
    if (this.messageObj.reminder === 1 && this.messageObj.isRead === 0) {
      this.tipDialog01 = false;
      this.tipDialog02 = true;
      this.startCountdown(1);
    } else {
      this.tipDialog01 = true;
      this.tipDialog02 = false;
      this.startCountdown(0);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
    this.intervalId = null;
  },
  methods: {
    // 关闭查看器
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    toRecyclingManagement() {
      this.$router.push('/views/wovenBagManagement/recyclingManagement');
      this.closeMessage();
    },
    // 倒计时
    startCountdown(flag) {
      this.isDisable = true;
      this.intervalId = window.setInterval(() => {
        if (flag === 1) {
          if (this.compulsionCountdown > 0) {
            this.compulsionCountdown--;
          } else {
            this.isDisable = false;
            clearInterval(this.intervalId); // 倒计时结束时清除定时器
          }
        } else {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            this.isDisable = false;
            clearInterval(this.intervalId); // 倒计时结束时清除定时器
            if (!flag) {
              this.closeMessage();
            }
          }
        }
      }, 1000);
    },
    // 点击关闭
    closeMessage() {
      const data = {
        messageInfo: false,
        messageInfoTime: 60
      };
      this.$store.commit('user/set_getmessageShow', data);
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    // 不再提示
    async notTip() {
      const data = {
        receiveId: store.getters.userId,
        clientType: 1,
        messageId: this.messageObj.messageId
      };
      this.closeMessage();
      const res = await readMessageUser(data);
      if (res.code === 200) {
        // this.$refs.popoverRef123.hide();
        this.bus.$emit('getMessage');
      }
    },
    // 查询系统消息
    async getMessage() {
      const data = {
        receiveId: store.getters.userId,
        clientType: 1
      };
      const res = await selectMessageUser(data);
      if (res.code === 200) {
        this.getmessageNumber = 0;
        if (res.data && res.data.length > 0) {
          this.messageList.forEach((item) => {
            if (item.isRead === 0) {
              item.isShow = 1; // 未读
              // 未读
              this.getmessageNumber = this.getmessageNumber + 1;
            } else {
              item.isShow = 0; // 已读
            }
          });
          this.$store.commit('user/set_getmessageNumber', this.getmessageNumber);
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.sysInfo {
  position: absolute;
  bottom: 0;
  width: 595px !important;
  right: 0;
  color: #142957;
  background: #ffffff;
  box-shadow: 0 0 16px rgba(6, 53, 157, 0.14);
  opacity: 1;
  border-radius: 4px;
  padding-bottom: 10px;
  z-index: 99999;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px 15px 20px;
    font-size: 16px;
    font-weight: bold;
    opacity: 1;
    cursor: pointer;
    background-color: #f2f2f2;
    color: black;
  }

  .infoContant {
    padding: 10px 10px 10px 20px;
    line-height: 25px;
    height: 250px;
    overflow-x: hidden; /* 隐藏x轴滚动条，但这不是必须的，因为默认就是visible */
    word-wrap: break-word;
    overflow-y: auto;
  }
}
</style>
